import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { SUBSCRIPTION_STATUS } from 'src/features/subscriptions/utils/types';
import { subscriptionsMessages } from 'src/features/subscriptions/utils/messages';

export const SUBSCRIPTIONS_STATUS_BADGE_OPTIONS: Record<SUBSCRIPTION_STATUS, BadgeOption> = {
    [SUBSCRIPTION_STATUS.ACTIVE]: {
        label: subscriptionsMessages.active,
        theme: 'green',
        icon: ICON_MAP.CHECK,
    },
    [SUBSCRIPTION_STATUS.CANCELLED]: {
        label: subscriptionsMessages.cancelled,
        theme: 'red',
        icon: ICON_MAP.X_MARK,
    },
    [SUBSCRIPTION_STATUS.ENDED]: {
        label: subscriptionsMessages.endedSubscription,
        theme: 'gray',
        icon: ICON_MAP.PAST,
    },
    [SUBSCRIPTION_STATUS.FROZEN]: {
        label: subscriptionsMessages.frozen,
        theme: 'blue',
        icon: ICON_MAP.FROZEN,
    },
};
